import { Skeleton } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

export const ComparisonLandingSkeleton: React.FC = () => {
  return (
    <div className={styles['container']} data-name="ComparisonLandingSkeleton">
      <div className={styles['skeleton']}>
        <Skeleton width="100%" height={156} borderRadius={12} />
        <div className={styles['text']}>
          <Skeleton width={40} height={24} />
          <Skeleton width={80} height={20} />
        </div>
      </div>
    </div>
  );
};
